import { css } from 'aphrodite';
import moment from 'moment';
import { Skeleton } from '../../../../components-v2/Skeleton';
import { formatCurrencyAxisLabel } from '../../helpers/formatCurrencyAxisLabel';
import { IProducerRow } from './historyData';
import { PendingHistory } from './PendingHistory';
import { styleSheet } from './styles';

export const ProducerMatrix = ({
	months,
	rows,
	loading,
	firstMonthOn,
}: {
	months: string[];
	rows: IProducerRow[];
	loading?: boolean;
	/** Set while the first full month is still being tracked: the date it will show. */
	firstMonthOn?: string;
}) => (
	<section className={css(styleSheet.card)}>
		<div>
			<h3 className={css(styleSheet.cardTitle)}>Premium sold by producer</h3>
			<p className={css(styleSheet.cardSubtitle)}>
				New business premium by origination month, credited to the policy owner who wrote it.
			</p>
		</div>
		{firstMonthOn ? (
			<PendingHistory title={`First month shows on ${firstMonthOn}`}>
				Credits each new policy to the producer who wrote it, even if it changes hands later.
			</PendingHistory>
		) : loading ? (
			<Skeleton>
				<p className={css(styleSheet.empty)}>Loading premium by producer...</p>
			</Skeleton>
		) : rows.length === 0 ? (
			<p className={css(styleSheet.empty)}>No new business written in this period yet.</p>
		) : (
			<div className={css(styleSheet.tableScroll)}>
				<table className={css(styleSheet.table)}>
					<thead>
						<tr>
							<th className={css(styleSheet.th, styleSheet.firstColumn)}>Producer</th>
							{months.map(month => (
								<th key={month} className={css(styleSheet.th)}>
									{moment(month, 'YYYY-MM').format('MMM')}
								</th>
							))}
							<th className={css(styleSheet.th)}>{months.length} months</th>
						</tr>
					</thead>
					<tbody>
						{rows.map(row => (
							<tr key={row.id}>
								<td className={css(styleSheet.td, styleSheet.firstColumn)}>{row.label}</td>
								{row.cells.map((value, i) => (
									<td key={months[i]} className={css(styleSheet.td)}>
										{value ? formatCurrencyAxisLabel(value) : '—'}
									</td>
								))}
								<td className={css(styleSheet.td, styleSheet.strong)}>{formatCurrencyAxisLabel(row.total)}</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		)}
	</section>
);
